'use strict';

angular.module('docketbook').
  controller('selectPersonController', function(userService, $rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout, $q) {

    // Initialise variables to be used
    $scope.personSearch = "";
    $scope.personSearchLoading = false;
    $scope.personLoadingError = null;
    $scope.personSearchList = [];
    $scope.personSearchListFull = [];
    $scope.personSelectCallback = null;
    $scope.desktopSelected = [];
    $scope.listCount = 0;
    $scope.assigned = [];

    $scope.query = {
      limit: 10,
      page: 1,
      order: 'first'
    };

    /***************************************/
    /***** Parent Controlled Functions *****/
    /***************************************/

    $scope.$parent.personSelectFromParent = function(assigned, cb) {
      $scope.personSearch = "";
      $scope.personSearchLoading = false;
      if ( assigned != null ) {
        $scope.assigned = assigned;
      } else {
        $scope.assigned = [];
      }
      $scope.personSelectCallback = cb;

      $scope.loadPeopleList();
    }

    $scope.loadPeopleList = function() {
      $scope.personSearchLoading = true;
      $scope.promise = $q(function(resolve, reject) {
        var queryParams = {};
        if ( $stateParams.device == 'desktop' ) {
          queryParams.limit = $scope.query.limit;
          queryParams.offset = $scope.query.limit * ($scope.query.page - 1);
          queryParams.sort = $scope.query.order;
        }
        if ( $scope.searchText != null && $scope.searchText != "" ) {
          queryParams.search = $scope.searchText;
        }
        if ( $scope.orgFull ) {
          userService.getMembers(queryParams, function(returnObject) {
            $scope.personSearchList = returnObject;
            if ( queryParams.offset <= 0 && returnObject.length < queryParams.limit ) {
              $scope.listCount = returnObject.length;
            } else {
              $scope.listCount = queryParams.offset + (queryParams.limit + 1);
            }
            for ( var i = 0; i < $scope.personSearchList.length; i++ ) {
              // check if person is in assigned list
              for ( var j = 0; j < $scope.assigned.length; j++ ) {
                if ( $scope.assigned[j] == $scope.personSearchList[i].id ) {
                  $scope.personSearchList[i].assigned = true;
                  break;
                }
              }
            }
            $scope.personSearchLoading = false;
            resolve('Done');
          }, function(err) {
            $scope.personSearchLoading = false;
            $scope.personLoadingError = "Error getting people";
            reject('Error');
          });
        } else {
          userService.getGroupMembers(queryParams, function(returnObject) {
            $scope.personSearchList = returnObject;
            if ( queryParams.offset <= 0 && returnObject.length < queryParams.limit ) {
              $scope.listCount = returnObject.length;
            } else {
              $scope.listCount = queryParams.offset + (queryParams.limit + 1);
            }
            for ( var i = 0; i < $scope.personSearchList.length; i++ ) {
              // check if person is in assigned list
              for ( var j = 0; j < $scope.assigned.length; j++ ) {
                if ( $scope.assigned[j].assignee == $scope.personSearchList[i].id && $scope.assigned[j].delete != true ) {
                  $scope.personSearchList[i].assigned = true;
                  break;
                }
              }
            }
            $scope.personSearchLoading = false;
            resolve('Done');
          }, function(err) {
            $scope.personSearchLoading = false;
            $scope.personLoadingError = "Error getting people";
            reject('Error');
          });
        }
      });
    }

    $scope.searchPeopleChange = function(searchText) {
      $scope.searchText = searchText;
      $scope.loadPeopleList();
    }

    $scope.$parent.desktopPeopleSelectFromParent = function(assigned, cb) {
      $scope.personSearch = "";
      $scope.personSelectCallback = cb;
      $scope.desktopSelected = [];
      $scope.orgFull = false;
      if ( assigned == null ) {
        $scope.assigned = [];
      } else {
        $scope.assigned = assigned;
      }
      $scope.query = {
        limit: 10,
        page: 1,
        order: 'first'
      };
      $scope.loadPeopleList();
      $("#selectPersonModal").fadeIn(100);
			$("input[name='selectPersonInput']").focus();
    }

    $scope.$parent.selectOrgPeopleFromParent = function(assigned, cb) {
      $scope.personSearch = "";
      $scope.personSelectCallback = cb;
      $scope.desktopSelected = [];
      $scope.orgFull = true;
      if ( assigned == null ) {
        $scope.assigned = [];
      } else {
        $scope.assigned = assigned;
      }
      $scope.query = {
        limit: 10,
        page: 1,
        order: 'first'
      };
      $scope.loadPeopleList();
      $("#selectPersonModal").fadeIn(100);
			$("input[name='selectPersonInput']").focus();
    }

    $scope.selectPersonToAssign = function(person) {
      $scope.personSelectCallback(person);
    }

    $scope.closePersonSelectList = function() {
      if ( $stateParams.device == 'desktop' ) {
        $("#selectPersonModal").fadeOut(100);
      }
      $scope.personSelectCallback(null);
    }

    $scope.desktopSelectPeopleContinue = function() {
      $scope.personSelectCallback($scope.desktopSelected);
      $("#selectPersonModal").fadeOut(100);
    }

    /********************************/
    /***** Search Functionality *****/
    /********************************/

    $scope.updatePersonSearch = function(searchValue) {
      $scope.personSearchLoading = true;
      if ( searchValue === "" ) {
        $scope.personSearchList = $scope.personSearchListFull;
        return;
      }

      // update personSearchList with filtered results
      var filteredList = [];
      for ( var i = 0; i < $scope.personSearchListFull.length; i++ ) {
        if ( $scope.personSearchListFull[i].name.full.indexOf(searchValue) != -1 ) {
          filteredList.push($scope.personSearchListFull[i]);
        }
      }

      $scope.personSearchList = filteredList;
    }

});



// WEBPACK FOOTER //
// ./src/controllers/selectors/selectPersonController.js